import { Table, TableBody, TableRow } from '@mui/material';
import { DragDropContext, Droppable, DropResult, ResponderProvided } from 'react-beautiful-dnd';
import { DataTableProps } from '../table/DataTable';
import { TableHeadCustom } from '../table';
import { memo } from 'react';

interface DroppableListProps<T extends any>
  extends Omit<DataTableProps, 'onPerPage' | 'OnPage' | 'OmitPerPageAll'> {
  items: T[];
  onSetItems: (items: T[]) => void;
  saveCallback?: (items: T[]) => void;
}

/**
 * @deprecated Используйте {@link DroppableDataTableV2} вместо этого компонента.
 */
export function DroppableDataTable<T extends any>({
  items,
  params,
  tableHead,
  children,
  onSetItems,
  saveCallback,
}: DroppableListProps<T>) {
  const handleDragEnd = async (dropResult: DropResult, provided?: ResponderProvided) => {
    if (!dropResult.destination) {
      return;
    }

    if (dropResult.destination.index === dropResult.source.index) {
      return;
    }

    if (items) {
      const dragItems = Array.from(items);
      const [reorderedItem] = dragItems.splice(dropResult.source.index, 1);
      dragItems.splice(dropResult.destination.index, 0, reorderedItem);
      onSetItems(dragItems);

      if (saveCallback) saveCallback(dragItems);
    }
  };

  return (
    <Table sx={{ width: '100%', height: '100%' }}>
      <TableHeadCustom
        order={params ? (params.order === 'asc' ? 'desc' : 'asc') : undefined}
        orderBy={params ? params.order_by : undefined}
        tableHead={tableHead}
      />
      <DragDropContext onDragEnd={handleDragEnd}>
        <Droppable droppableId="dnd-table" direction="vertical">
          {(provided) => (
            <TableBody {...provided.droppableProps} ref={provided.innerRef}>
              {children}
              {provided.placeholder}
              <TableRow sx={{ height: '100%' }} />
            </TableBody>
          )}
        </Droppable>
      </DragDropContext>
    </Table>
  );
}

export const DroppableDataTableMemo = memo(DroppableDataTable) as <T>(
  props: DroppableListProps<T>
) => JSX.Element;
